module.exports = __webpack_public_path__ + "static/media/aside-reporting-system.d2ae95d2.jpg";